import { MediaAsset } from './MediaAsset';

export class Logo extends MediaAsset {
  get isAdult(): boolean | undefined {
    return false;
  }
}
